import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ProductGroupCollectionQuery, ProductGroupCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductGroupCollectionQuery)
@Wrapper(ProductGroupCollectionQueryHandlerBase)
export class ProductGroupCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
